(() => {
  const init = root => {
    if (root.dataset.nbReady) return;
    root.dataset.nbReady = 'true';
    const body = root.querySelector('[data-nb-body]');
    const toc = root.querySelector('.nb-toc');
    if (!body || !toc) return;
    const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
    const list = toc.querySelector('ol');
    if (headings.length > 1) {
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let candidate = 'nb-section-' + (index + 1);
          while (document.getElementById(candidate)) candidate += '-x';
          heading.id = candidate;
        }
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = heading.textContent;
        li.append(link); list.append(li);
      });
      toc.hidden = false;
      if (window.matchMedia('(max-width: 749px)').matches) toc.open = false;
      if ('IntersectionObserver' in window) {
        const links = [...list.querySelectorAll('a')];
        const observer = new IntersectionObserver(entries => {
          for (const entry of entries) if (entry.isIntersecting) {
            links.forEach(a => a.removeAttribute('aria-current'));
            links[headings.indexOf(entry.target)].setAttribute('aria-current', 'location');
          }
        }, { rootMargin: '-15% 0px -65% 0px' });
        headings.forEach(h => observer.observe(h));
      }
    }
    body.querySelectorAll('table').forEach(table => {
      const firstCells = [...table.querySelectorAll('tr')].map(row => row.cells[0]).filter(Boolean);
      if (firstCells.length && firstCells.every(cell => cell.textContent.trim().length < 26 && cell.colSpan === 1)) table.classList.add('nb-table-compact-first');
      const existing = table.closest('.nomads-table-scroll, .nb-table-wrap');
      if (existing) {
        existing.classList.add('nb-table-wrap');
        if (!existing.hasAttribute('tabindex')) existing.tabIndex = 0;
        return;
      }
      const wrap = document.createElement('div');
      wrap.className = 'nb-table-wrap'; wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', body.dataset.tableLabel);
      table.before(wrap); wrap.append(table);
    });
  };
  const run = () => document.querySelectorAll('[data-nb-article]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();

